(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/pages/validated/page-ab.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/pages/validated/page-ab.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  useState,
  useEffect
} = React;
const {
  Radio
} = svs.ui.reactForm;
const Button = svs.ui.ReactButton;
const {
  PageWrapper
} = svs.ticketsValidate.components;
const Envelope = svs.tur.Envelope;
const BubbleWinMessage = svs.tur.bubbleWinMessage.components.BubbleWinMessage;
const branding = svs.tickets.data.templateConfig.branding;
const {
  GamingAccountInfo
} = svs.ticketsValidate.components;
const {
  QrScanner,
  utils: {
    hasValidDevice
  }
} = svs.tur.qrScanner;
const WinRadioOptions = {
  BUY_DIGITAL: 'buy_digital',
  BUY_PHYSICAL: 'buy_physical',
  KEEP_WIN: 'keep_win',
  WITHDRAW: 'withdraw'
};
const RadioWinSelections = _ref => {
  let {
    onContinue,
    price,
    winAmount,
    isHighWin,
    paused
  } = _ref;
  const [selection, setSelection] = useState(paused ? WinRadioOptions.WITHDRAW : WinRadioOptions.BUY_DIGITAL);
  const envelopeTitle = 'Vad vill du göra med din vinst?';
  const plural = winAmount > price;
  const buyDigitalLabel = plural ? 'Byt in vinst till nya digitala lotter' : 'Byt in vinst till ny digital lott';
  const buyPhysicalLabel = plural ? 'Byt in vinst till nya fysiska lotter' : 'Byt in vinst till ny fysisk lott';
  const {
    BUY_DIGITAL,
    BUY_PHYSICAL,
    KEEP_WIN,
    WITHDRAW
  } = WinRadioOptions;
  const shouldShowBuyPhysicalOption = winAmount <= 150;
  const onRadioChange = e => {
    setSelection(e.target.value);
  };
  const confirmSelection = () => {
    onContinue === null || onContinue === void 0 || onContinue(selection);
  };
  if (isHighWin) {
    return React.createElement("div", {
      "data-testid": "tickets-validate-high-win"
    });
  }
  return React.createElement("div", {
    className: "u-flex u-flex-column u-flex-justify-content-center padding-bottom-1"
  }, React.createElement("h4", {
    className: "h4 margin-top-1"
  }, envelopeTitle), React.createElement("div", {
    className: "padding-h-1 align-left padding-bottom-1 child-margin-bottom-half"
  }, !paused && React.createElement(React.Fragment, null, React.createElement(Radio, {
    branding: "tur",
    checked: selection === BUY_DIGITAL,
    className: "margin-bottom-1",
    name: "radio-validate-win-selection",
    onChange: onRadioChange,
    value: BUY_DIGITAL
  }, buyDigitalLabel), shouldShowBuyPhysicalOption && React.createElement(Radio, {
    branding: "tur",
    checked: selection === BUY_PHYSICAL,
    name: "radio-validate-win-selection",
    onChange: onRadioChange,
    value: BUY_PHYSICAL
  }, buyPhysicalLabel)), React.createElement(Radio, {
    branding: "tur",
    checked: selection === KEEP_WIN,
    name: "radio-validate-win-selection",
    onChange: onRadioChange,
    value: KEEP_WIN
  }, "Beh\xE5ll vinst p\xE5 mitt spelkonto"), React.createElement(Radio, {
    branding: "tur",
    checked: selection === WITHDRAW,
    name: "radio-validate-win-selection",
    onChange: onRadioChange,
    value: WITHDRAW
  }, "Ta ut vinst fr\xE5n spelkonto")), React.createElement(Button, {
    block: true,
    inverted: true,
    onClick: confirmSelection,
    type: "button"
  }, "Forts\xE4tt"));
};
setGlobal('svs.ticketsValidate.pages.ValidatedWithABTest', _ref2 => {
  let {
    match
  } = _ref2;
  const {
    pathname
  } = ReactRouterDOM.useLocation();
  const [showQrScanner, setShowQrScanner] = useState(false);
  const [bubbleWinOptions, setBubbleWinOptions] = useState();
  const ticketInfo = svs.ticketsValidate.data.retailTicketInfo;
  const bTestValidated = svs.components.targeting.isTargeted('tickets_validate_validated', 'B');
  const productType = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type;
  const ticketId = match.params.ticketId;
  const shortName = svs.ticketsValidate.utils.getShortNameByTicketId(ticketId);
  const {
    state
  } = svs.ticketsValidate.components.context.useValidateContext();
  const {
    fetchingDepositLimits,
    hasDepositLimits = false
  } = svs.ticketsValidate.pages.validated.useDepositLimits();
  const isPausedOrHasDepositLimits = svs.tur.data.pauseCheck.isPaused || hasDepositLimits;
  const image = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.image;
  const result = state.result;
  const winAmount = (bubbleWinOptions === null || bubbleWinOptions === void 0 ? void 0 : bubbleWinOptions.amount) || 0;
  const brand = branding === 'triss' ? 'triss' : 'skrapspel';
  const trackType = shortName || productType;
  useEffect(() => {
    const normalizedWin = svs.ticketUtility.utils.normalizeWinRetail(result);
    setBubbleWinOptions(_objectSpread({
      demo: false,
      product: ticketInfo.type,
      disableGrassroot: true
    }, normalizedWin));
    if (normalizedWin.winFlag) {
      setTimeout(() => {
        svs.tur.confettiCannon();
      }, 750);
    }
  }, [result, ticketInfo]);
  const onBuyDigitalTickets = function () {
    let abTest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'A';
    svs.ticketgames.ticketUtility.utils.tracking.trackValidateBuyNewTicketsOnlineChosen(trackType, abTest);
    if (winAmount < ticketInfo.price || winAmount > 150) {
      const home = svs.core.data.baseUrl.includes('triss') ? svs.core.urlMapping.get('trissHome') : svs.core.urlMapping.get('skrapspelHome');
      svs.utils.url.navigate("".concat(home, "?rl=").concat(encodeURIComponent(JSON.stringify({
        winAmount
      }))));
    } else {
      const returnUrl = encodeURIComponent("".concat(svs.core.data.baseUrl).concat(pathname));
      svs.utils.url.navigate("/".concat(brand, "/kop-flera/kop/").concat(productType, "?vinst=").concat(winAmount, "&returnUrl=").concat(returnUrl));
    }
  };
  const onBuyPhysicalTickets = function () {
    let abTest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'A';
    svs.ticketgames.ticketUtility.utils.tracking.trackValidateBuyNewTicketsOfflineChosen(trackType, abTest);
    const returnUrl = encodeURIComponent("".concat(svs.core.data.baseUrl).concat(pathname));
    svs.utils.url.navigate("/".concat(brand, "/vardekod/").concat(productType, "?vinst=").concat(winAmount, "&returnUrl=").concat(returnUrl));
  };
  const onWithdraw = function () {
    let abTest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'A';
    svs.ticketgames.ticketUtility.utils.tracking.trackValidateWithdrawal(trackType, abTest);
    const returnUrl = encodeURIComponent("".concat(svs.core.data.baseUrl).concat(pathname));
    svs.utils.url.navigate("".concat(svs.core.urlMapping.get('transactionsWithdrawal'), "?returnUrl=").concat(returnUrl, "&withdrawalAmount=").concat(winAmount));
  };
  const onValidateNewTicket = function (e) {
    let abTest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'A';
    e === null || e === void 0 || e.preventDefault();
    svs.ticketgames.ticketUtility.utils.tracking.trackValidateCorrectNewTicket(trackType, abTest);
    const ticketsValidateManualUrl = svs.core.urlMapping.get('ticketsValidateManual');
    svs.utils.url.navigate(ticketsValidateManualUrl);
  };
  if (fetchingDepositLimits) {
    return null;
  }
  if (bubbleWinOptions !== null && bubbleWinOptions !== void 0 && bubbleWinOptions.amount && bTestValidated) {
    const {
      leaveInAccountDialog
    } = svs.ticketsValidate.utils;
    const onQRCodeDetected = url => {
      svs.ui.loader.show();
      svs.utils.url.navigate(url);
    };
    const validateQrCode = url => {
      const {
        matchPath
      } = ReactRouterDOM;
      const qrUrl = new URL(url);
      const match = matchPath(qrUrl === null || qrUrl === void 0 ? void 0 : qrUrl.pathname, {
        path: '/rl/:ticketId'
      });
      if (!match) {
        throw new Error('Invalid QR code');
      }
      svs.ticketgames.ticketMappings.productMappings.getProductByTicketId(match.params.ticketId);
    };
    const handleCorrectNewTicket = e => {
      if (hasValidDevice()) {
        svs.ticketgames.ticketUtility.utils.tracking.trackValidateCorrectNewTicket(trackType, 'B');
        setShowQrScanner(true);
      } else {
        onValidateNewTicket(e, 'B');
      }
    };
    if (showQrScanner) {
      return React.createElement(QrScanner, {
        handleQRCodeDetected: onQRCodeDetected,
        onClose: () => setShowQrScanner(false),
        validateQrCode: validateQrCode
      });
    }
    return React.createElement(PageWrapper, {
      className: "validated-page padding-top-3"
    }, bubbleWinOptions && React.createElement("div", {
      className: "bubble-win-message-wrapper"
    }, React.createElement(BubbleWinMessage, {
      options: bubbleWinOptions
    })), React.createElement("div", {
      className: "u-flex u-flex-justify-content-center"
    }, React.createElement("div", {
      className: "u-flex u-flex-column u-flex-align-items-center tickets-validate-envelope-width"
    }, React.createElement(Envelope, {
      branding: branding,
      className: "w100",
      image: image,
      repeatImage: 1
    }, React.createElement("div", {
      className: "u-flex u-flex-column u-flex-justify-content-center padding-top-2"
    }, !isPausedOrHasDepositLimits && React.createElement(Button, {
      block: true,
      className: "margin-bottom-1",
      focus: true,
      onClick: () => onBuyDigitalTickets('B'),
      type: "button"
    }, "Byt in din vinst till nya digitala lotter"), React.createElement(Button, {
      block: true,
      className: "margin-bottom-1",
      onClick: () => {
        leaveInAccountDialog({
          onValidateNewTicket: handleCorrectNewTicket,
          brand
        });
      },
      transparent: true,
      type: "button"
    }, "L\xE5t vinsten ligga kvar p\xE5 ditt spelkonto"), React.createElement(Button, {
      block: true,
      className: "margin-bottom-1",
      onClick: () => onWithdraw('B'),
      transparent: true,
      type: "button"
    }, "Ta ut vinst fr\xE5n spelkonto"), React.createElement(Button, {
      block: true,
      className: "margin-bottom-1-half",
      onClick: () => onBuyPhysicalTickets('B'),
      transparent: true,
      type: "button"
    }, "Byt in vinst till nya fysiska lotter"), React.createElement(GamingAccountInfo, null))))));
  }
  const onKeepWin = e => {
    e === null || e === void 0 || e.preventDefault();
    svs.ticketgames.ticketUtility.utils.tracking.trackValidateKeepWinChosen(shortName);
    svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      type: svs.ui.dialog.type.INFO,
      icon: 'thumbs-up',
      title: 'Toppen!',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        align: svs.ui.dialog.message.align.CENTER,
        text: 'Nu vilar din vinst tryggt på ditt spelkonto och kan bland annat användas för att köpa nya spel.'
      }, {
        type: svs.ui.dialog.message.TEXT,
        align: svs.ui.dialog.message.align.CENTER,
        text: 'All information om dina köp och vinster hittar du i Mina spel.'
      }],
      actions: [{
        title: 'Okej',
        callback: (e, forms, dialog) => {
          dialog === null || dialog === void 0 || dialog.close();
          let ticketsValidateDoneKeepWinUrl;
          switch (brand) {
            case 'triss':
              ticketsValidateDoneKeepWinUrl = svs.core.urlMapping.get('ticketsValidateDoneKeepWinTriss');
              break;
            case 'skrapspel':
              ticketsValidateDoneKeepWinUrl = svs.core.urlMapping.get('ticketsValidateDoneKeepWinSkrapspel');
              break;
            default:
              ticketsValidateDoneKeepWinUrl = svs.core.urlMapping.get('ticketsValidateManual');
          }
          svs.utils.url.navigate(ticketsValidateDoneKeepWinUrl);
        }
      }]
    }));
  };
  const onWinSelectionConfirmed = selection => {
    switch (selection) {
      case WinRadioOptions.BUY_DIGITAL:
        onBuyDigitalTickets();
        break;
      case WinRadioOptions.BUY_PHYSICAL:
        onBuyPhysicalTickets();
        break;
      case WinRadioOptions.KEEP_WIN:
        onKeepWin();
        break;
      case WinRadioOptions.WITHDRAW:
        onWithdraw();
        break;
      default:
        break;
    }
  };
  return React.createElement(PageWrapper, {
    className: "validated-page padding-top-3"
  }, bubbleWinOptions && React.createElement("div", {
    className: "bubble-win-message-wrapper"
  }, React.createElement(BubbleWinMessage, {
    options: bubbleWinOptions
  })), React.createElement("div", {
    className: "u-flex u-flex-justify-content-center"
  }, React.createElement(Envelope, {
    branding: branding,
    image: image,
    repeatImage: 1
  }, bubbleWinOptions !== null && bubbleWinOptions !== void 0 && bubbleWinOptions.amount ? React.createElement(RadioWinSelections, {
    isHighWin: bubbleWinOptions.extraicon,
    onContinue: onWinSelectionConfirmed,
    paused: isPausedOrHasDepositLimits,
    price: ticketInfo.price,
    winAmount: bubbleWinOptions.amount
  }) : React.createElement("div", {
    className: "u-flex u-flex-column u-flex-justify-content-center padding-top-2"
  }, !isPausedOrHasDepositLimits && React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    focus: true,
    onClick: onBuyDigitalTickets,
    type: "button"
  }, "K\xF6p ny digital lott"), React.createElement(Button, {
    block: true,
    className: isPausedOrHasDepositLimits ? 'margin-top-1' : '',
    focus: true,
    onClick: onValidateNewTicket,
    transparent: true,
    type: "button"
  }, "R\xE4tta ny lott")), result.winAmount > 0 && React.createElement(GamingAccountInfo, null))));
});

 })(window);